import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { businessInfo } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-gradient-to-r from-sky-500 to-cyan-500 text-white px-3 py-1.5 rounded-lg font-bold text-lg">
                DrMobil
              </div>
              <span className="text-white font-semibold">Strommen</span>
            </div>
            <p className="text-sm leading-relaxed">
              Din pålitelige partner for reparasjon av mobil, PC, og nettbrett. 
              Kvalitet og service siden dag én.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hurtiglenker</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-sky-400 transition-colors">
                  Hjem
                </Link>
              </li>
              <li>
                <Link to="/tjenester" className="text-sm hover:text-sky-400 transition-colors">
                  Tjenester
                </Link>
              </li>
              <li>
                <Link to="/priser" className="text-sm hover:text-sky-400 transition-colors">
                  Priser
                </Link>
              </li>
              <li>
                <Link to="/om-oss" className="text-sm hover:text-sky-400 transition-colors">
                  Om oss
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm hover:text-sky-400 transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Kontakt oss</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin size={18} className="text-sky-400 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{businessInfo.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={18} className="text-sky-400 flex-shrink-0" />
                <a href={`tel:${businessInfo.phone}`} className="text-sm hover:text-sky-400 transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={18} className="text-sky-400 flex-shrink-0" />
                <a href={`mailto:${businessInfo.email}`} className="text-sm hover:text-sky-400 transition-colors">
                  {businessInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="text-white font-semibold mb-4">Åpningstider</h3>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <Clock size={18} className="text-sky-400 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <div className="font-medium text-white">Man - Fre</div>
                  <div>{businessInfo.openingHours.weekdays}</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Clock size={18} className="text-sky-400 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <div className="font-medium text-white">Lørdag</div>
                  <div>{businessInfo.openingHours.saturday}</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Clock size={18} className="text-sky-400 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <div className="font-medium text-white">Søndag</div>
                  <div>{businessInfo.openingHours.sunday}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p className="text-sm">
            &copy; {currentYear} {businessInfo.name}. Alle rettigheter reservert.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
